
import React from 'react';

const Footer = () => {
   return (
      <div className='mt-auto flex bg-error-12 w-full h-10'>
         Site footer
      </div>

   );
}
Footer.propTypes = {
};
Footer.defaultProps = {
}
export default Footer;


